import { useState } from 'react'
import { GraphQLError } from 'graphql'
import { IError } from 'types/graphqlTypes'
import { useCreateTrailerMutation } from '../graphql/CreateTrailerMutation'
import { ITrailerSchema } from '../schema/TrailerSchema'

const getErrors = (
  errors?: readonly GraphQLError[],
  responseErrors?: Pick<IError, 'message'>[]
) => {
  if (errors && errors.length > 0) {
    return errors.map(e => e.message).join('; ')
  }
  if (responseErrors && responseErrors.length > 0) {
    return responseErrors.map(e => e.message).join('; ')
  }
  return null
}

export const useAddTrailers = () => {
  const [createTrailer] = useCreateTrailerMutation()
  const [errors, setErrors] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const addTrailer = async (formData: ITrailerSchema) => {
    setLoading(true)
    let newErrors = null
    let newTrailerId
    try {
      const { data, errors: graphQLErrors } = await createTrailer({
        variables: {
          input: {
            motorCarrierId: formData.carrier,
            trailerNumber: formData.trailerNumber,
            trailerLength: formData.trailerLength,
            trailerType: formData.trailerType,
          },
        },
        refetchQueries: ['Trailers'],
      })

      const { createTrailer: response } = data || {}
      const { errors: responseErrors } = response || {}

      newErrors = getErrors(graphQLErrors, responseErrors)

      if (!newErrors) {
        newTrailerId = response?.trailer?.id
      }
    } catch (e) {
      newErrors = 'There was an error creating trailer'
    }

    setLoading(false)
    setErrors(newErrors)
    return {
      id: newTrailerId,
      errors: newErrors,
    }
  }

  return {
    errors,
    addTrailer,
    loading,
  }
}
